module.exports = __webpack_public_path__ + "media/src/images/question_mark-0dffe48d5089b55472a6af7700214b9f.png";